import { Requester, apiClientWithTenantIdHeader } from '@/features/api/client.service.js'
import { createBaseEndpoints } from '@/features/api/services/utils/createBaseEndpoints.js'
import { makeApiRequest } from '@/features/api/services/utils/makeApiRequest.js'
import { makeFormData } from '@/features/api/services/utils/makeFormData.js'
import { useAuthStore } from '@/features/auth/useAuthStore.js'

export const managementApiEndpoints = {
  tenantRegContactDetail: '/Management/TenantRegistrationContactDetail',
  tenantRegContactDetailUpdate: '/Management/TenantRegistrationContactDetail/Update',
  tenantRegDefinitionDetail: '/Management/TenantRegistrationDefinition',
  tenantRegDefinitionDetailUpdate: '/Management/TenantRegistrationDefinition/Update',
  tenantRegOrganisationDetail: '/Management/TenantRegistrationOrganisationDetail',
  tenantRegOrganisationDetailUpdate: '/Management/TenantRegistrationOrganisationDetail/Update',
  tenantRegStructureDetail: '/Management/TenantRegistrationStructureDetail',
  tenantRegStructureDetailUpdate: '/Management/TenantRegistrationStructureDetail/Update',
  tenantRegUploadLogo: '/Management/TenantLogo/UploadImage',
  tenantRegDownloadLogo: '/Management/TenantLogo/DownloadImage',
  tenantRegUploadAppLogo: '/Management/TenantAppLogo/UploadImage',
  tenantRegDownloadAppLogo: '/Management/TenantAppLogo/DownloadImage',
  tenantRegTerminologyDetail: '/Management/TenantRegistrationTenantTerminology',
  tenantRegTerminologyDetailUpdate: '/Management/TenantRegistrationTenantTerminology/Update',
  tenantRegComponentDetail: '/Management/TenantRegistrationTenantComponent',
  tenantRegComponentDetailUpdate: '/Management/TenantRegistrationTenantComponent/Update',
  tenantRegBackgroundImageDownload: '/Management/TenantBackgroundImage/DownloadImage',
  tenantRegBackgroundImageUpload: '/Management/TenantBackgroundImage/UploadImage',
  tenantRegProfileFinalize:
    '/Management/TenantRegistrationFinalize/UpdateProfileRegistrationStatus',
  tenantRegTenantRegistrationFinalize:
    '/Management/TenantRegistrationFinalize/UpdateTenantRegistrationStatus',
  tenantRegSportCategoryDetail: '/Management/TenantRegistrationSportCategory',
  tenantRegSportCategoryUpdate: '/Management/TenantRegistrationSportCategory/Update',
  profileDetails: '/Management/Profile/GetMyProfileDetails',
  profileDetailsUpdate: '/Management/Profile/UpdateMyProfileDetails',
  profileGetAllSuperAdminAndLimited: '/Management/Profile/GetAllSuperAdminAndLimited',
  profileAddProfileSuperAdminLimited: '/Management/Profile/AddProfileSuperAdminLimited',
  profileUpdateProfileSuperAdminLimited: '/Management/Profile/UpdateProfileSuperAdminLimited',
  profileMakeProfileToSuperAdminLimited: '/Management/Profile/MakeProfileToSuperAdminLimited',
  profileGetProfileSuperAdminLimitedTenants:
    '/Management/Profile/GetProfileSuperAdminLimitedTenants',
  profileAddProfileSuperAdminLimitedToTenant:
    '/Management/Profile/AddProfileSuperAdminLimitedToTenant',
  profileRemoveProfileSuperAdminLimitedTenant:
    '/Management/Profile/RemoveProfileSuperAdminLimitedTenant',
  profileUpdateProfileSuperAdminLimitedTenantRole:
    '/Management/Profile/UpdateProfileSuperAdminLimitedTenantRole',
  tenantRegistrationProfile: '/Management/TenantRegistrationProfile',
  tenantRegistrationProfileUpdate: '/Management/TenantRegistrationProfile/Update',
  inventory: createBaseEndpoints('/Management/Inventory'),
  inventoryImage: {
    upload: '/Management/InventoryImage/UploadImage',
    download: '/Management/InventoryImage/DownloadImage',
  },
  membership: createBaseEndpoints('/Management/Membership'),
  membershipDetail: createBaseEndpoints('/Management/MembershipDetail'),
  memberRegistration: createBaseEndpoints('/Management/MemberRegistration'),
  memberRegistrationUpdateStatus: '/Management/MemberRegistration/UpdateStatus',
  memberRegistrationProfileMembership: '/Management/MemberRegistration/ProfileMembership',
  memberRegistrationFinalize: '/Management/MemberRegistration/Finalize',
  memberRegistrationCart: '/Management/MemberRegistrationCart',
  memberRegistrationCartAdd: '/Management/MemberRegistrationCart/Add',
  memberRegistrationCartRemove: '/Management/MemberRegistrationCart/Remove',
  baseFee: createBaseEndpoints('/Management/BaseFee'),
  memberTypeBaseFee: createBaseEndpoints('/Management/MemberTypeBaseFee'),
  tenant: createBaseEndpoints('/Management/Tenant'),
  tenantLimitedList: '/Management/Tenant/GetLimitedTenantList',
  tenantOsiAccess: createBaseEndpoints('/Management/TenantOsiAccess'),
  getTenantProfileList: '/Management/GlobalProfile/GetTenantProfileList',
  getTenantProfileListNoUsers: '/Management/GlobalProfile/GetTenantProfileListNoUsers',
  getTenantGroupList: '/Management/GlobalProfile/GetTenantGroupList',
  getGroupCodeList: '/Management/GlobalProfile/GetGroupCodeList',
  getTenantProfileDetailGlobal: 'Management/GlobalProfile/GetTenantProfileDetail',
  myTenantDetails: 'Authorization/Authentication/MyTenantDetails',
  mobileTenantList: '/Authorization/Authentication/MobileTenantList',
  publicFileUpload: '/Management/PublicFile/UploadFile',
  publicFileDownload: '/Management/PublicFile',
  tenantOsiSettings: '/Management/TenantOsiSettings',
  selector: '/Management/Selector',
  selectorEmbeds: '/Management/Selector/embeds',
  selectorEmbedSub: '/Management/Selector/embedsub',
  selectorGetEmailRecipients: '/Management/Selector/GetEmailRecipients',
  getTenantGroupDetailWithSubGroup: '/Management/GlobalProfile/GetTenantGroupDetailWithSubGroup',
  // TenantMobile endpoints
  tenantMobile: createBaseEndpoints('/Management/TenantMobile'),
  tenantMobileUpdateStatus: '/Management/TenantMobile/UpdateStatus',
  tenantMobileGetDetails: '/Management/TenantMobile/GetDetails',
  tenantMobileRecover: '/Management/TenantMobile/Recover',
  // TenantMobileContact endpoints
  tenantMobileContact: '/Management/TenantMobileContact',
  tenantMobileContactAdd: '/Management/TenantMobileContact/Add',
  tenantMobileContactUpdate: '/Management/TenantMobileContact/Update',
  tenantMobileContactRemove: '/Management/TenantMobileContact/Remove',
  // TenantMobileGroup endpoints
  tenantMobileGroup: '/Management/TenantMobileGroup',
  tenantMobileGroupAdd: '/Management/TenantMobileGroup/Add',
  tenantMobileGroupRemove: '/Management/TenantMobileGroup/Remove',
  sendNotification: '/Management/Notification/SendNotification',
  notificationList: '/Management/Notification',
  getTenantNotification: '/Management/Notification/GetTenantNotification',
  notificationDetail: '/Management/Notification/GetTenantNotificationDetail',
  notificationGetStartChatRecordList: '/Management/MobileChat/GetStartChatRecords',
  notificationGetChatRecordList: '/Management/MobileChat/GetChatRecords',
  mobileChatReportList: '/Management/MobileChat/GetChatReports',
  mobileChatReportDetail: '/Management/MobileChat/GetChatReportDetail',
  mobileChatHide: '/Management/MobileChat/HideChat',
  tenantSportType: '/Management/TenantSportType',
  tenantSportTypeAdd: '/Management/TenantSportType/Add',
  tenantSportTypeRemove: '/Management/TenantSportType/Remove',
  tenantReport: '/Management/TenantReport',
  mobileGroupAddChatGroup: '/Management/MobileGroup/AddChatGroup',
  mobileGroupRemoveChatGroup: '/Management/MobileGroup/RemoveChatGroup',
  mobileGroupGetGroupTerms: '/Management/MobileGroup/GetGroupTerms',
  mobileGroupAddChatGroupMember: '/Management/MobileGroup/AddChatGroupMember',
  mobileGroupGetSelectedTermsGroup: '/Management/MobileGroup/GetSelectedTermsGroup',
  getProfileGroupsV2NoMobileConnection:
    '/Management/MobileGroup/GetProfileGroupsV2NoMobileConnection',
  oaSystemTables: '/Management/OASystems/Tables',
  tenantCode: '/Management/TenantCode',
  tenantCodeGetDetails: '/Management/TenantCode/GetDetails',
  tenantGroup: '/Management/TenantGroup',
  tenantGroupGetDetails: '/Management/TenantGroup/GetDetails',
  tenantTerm: '/Management/TenantTerm',
  tenantTermGetDetails: '/Management/TenantTerm/GetDetails',
  tenantTermGroup: '/Management/TenantTermGroup',
  tenantTermGroupMember: '/Management/TenantTermGroupMember',
}

export const FeeFrequency = {
  MembershipLength: 10,
  OneOffJoiningFee: 20,
  WeeklyFee: 30,
  FortnightlyFee: 40,
  MonthlyFee: 50,
}

export function getFeeFrequencyLabel(feeFrequency) {
  switch (feeFrequency) {
    case FeeFrequency.MembershipLength:
      return 'Membership length?'
    case FeeFrequency.OneOffJoiningFee:
      return 'One-off joining fee'
    case FeeFrequency.WeeklyFee:
      return 'Weekly fee'
    case FeeFrequency.FortnightlyFee:
      return 'Fortnightly fee'
    case FeeFrequency.MonthlyFee:
      return 'Monthly fee'
    default:
      return 'Unknown'
  }
}

export const RouteType = {
  General: 5, // Link
  SimpleAnnouncement: 10, // Basic
  Chat: 20, // Question
  Event: 30, // Event
}

export function getRouteType(routeType) {
  switch (routeType) {
    case RouteType.General:
      return 'Link'
    case RouteType.SimpleAnnouncement:
      return 'Basic'
    case RouteType.Chat:
      return 'Question'
    case RouteType.Event:
      return 'Event'
    default:
      return '-'
  }
}

export const ManagementApi = {
  profileGetAllSuperAdminAndLimited: async ({ numberOfObjectsPerPage = 999999 } = {}) =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.profileGetAllSuperAdminAndLimited,
        data: makeFormData({ numberOfObjectsPerPage }),
      }),
    )(),

  profileAddProfileSuperAdminLimited: async ({ email, firstName, lastName, dateOfBirth, gender }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.profileAddProfileSuperAdminLimited,
        data: makeFormData({
          Email: email,
          FirstName: firstName,
          LastName: lastName,
          DateOfBirth: dateOfBirth,
          Gender: gender,
        }),
      }),
    )(),

  profileUpdateProfileSuperAdminLimited: async ({
    id,
    email,
    firstName,
    lastName,
    dateOfBirth,
    gender,
  }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.profileUpdateProfileSuperAdminLimited,
        queryParams: { Id: id },
        data: makeFormData({
          Id: id,
          Email: email,
          FirstName: firstName,
          LastName: lastName,
          DateOfBirth: dateOfBirth,
          Gender: gender,
        }),
      }),
    )(),

  profileMakeProfileToSuperAdminLimited: async profileId =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.profileMakeProfileToSuperAdminLimited,
        queryParams: { ProfileId: profileId },
      }),
    )(),

  profileGetProfileSuperAdminLimitedTenants: async profileId =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.profileGetProfileSuperAdminLimitedTenants,
        queryParams: { Id: profileId },
      }),
    )(),

  profileAddProfileSuperAdminLimitedToTenant: async ({ profileId, tenantId, roleGroupId }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.profileAddProfileSuperAdminLimitedToTenant,
        data: makeFormData({
          ProfileId: profileId,
          TenantId: tenantId,
          RoleGroupId: roleGroupId,
        }),
      }),
    )(),

  profileRemoveProfileSuperAdminLimitedTenant: async profileTenantId =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.profileRemoveProfileSuperAdminLimitedTenant,
        queryParams: { ProfileTenantId: profileTenantId },
      }),
    )(),

  profileUpdateProfileSuperAdminLimitedTenantRole: async ({ profileTenantId, roleGroupId }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.profileUpdateProfileSuperAdminLimitedTenantRole,
        queryParams: { ProfileTenantId: profileTenantId },
        data: makeFormData({ RoleGroupId: roleGroupId }),
      }),
    )(),

  tenantGetLimitedList: async ({ numberOfObjectsPerPage = 999999 } = {}) =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantLimitedList,
        data: makeFormData({ numberOfObjectsPerPage }),
      }),
    )(),

  oaSystemTables: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.oaSystemTables,
      }),
    )(),

  oaSystemTable: async logicalName =>
    makeApiRequest(() =>
      Requester.put({
        url: `${managementApiEndpoints.oaSystemTables}/${encodeURIComponent(logicalName)}`,
      }),
    )(),

  oaSystemTableData: async logicalName =>
    makeApiRequest(() =>
      Requester.put({
        url: `${managementApiEndpoints.oaSystemTables}/${encodeURIComponent(logicalName)}/Data`,
      }),
    )(),

  tenantCodeGetDetails: async ({ tenantId, id }) =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantCodeGetDetails,
        queryParams: { id },
        apiClient: apiClientWithTenantIdHeader(tenantId),
      }),
    )(),

  tenantGroupGetDetails: async ({ tenantId, id }) =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantGroupGetDetails,
        queryParams: { id },
        apiClient: apiClientWithTenantIdHeader(tenantId),
      }),
    )(),

  tenantTermGetDetails: async ({ tenantId, id }) =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantTermGetDetails,
        queryParams: { id },
        apiClient: apiClientWithTenantIdHeader(tenantId),
      }),
    )(),

  tenantRegContactDetail: async tenantId =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantRegContactDetail,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
      }),
    )(),

  tenantRegContactDetailUpdate: async (tenantId, data) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantRegContactDetailUpdate,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
        data: makeFormData({
          PhoneNumber: data.phoneNumber,
          EmailAddress: data.emailAddress,
          Website: data.website,
          Address: data.address,
          Suburb: data.suburb,
          City: data.city,
          State: data.state,
          PostCode: data.postCode,
          AddressCountry: data.addressCountry,
          Facebook: data.facebook,
          Instagram: data.instagram,
          isPublic_PhoneNumber: data.isPublic_PhoneNumber,
          isPublic_EmailAddress: data.isPublic_EmailAddress,
          isPublic_Website: data.isPublic_Website,
          isPublic_Address: data.isPublic_Address,
          isPublic_Facebook: data.isPublic_Facebook,
          isPublic_Instagram: data.isPublic_Instagram,
        }),
      }),
    )(),

  tenantRegOrganisationDetail: async tenantId =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantRegOrganisationDetail,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
      }),
    )(),

  tenantRegOrganisationDetailUpdate: async (tenantId, data) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantRegOrganisationDetailUpdate,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
        data: makeFormData({
          Name: data.name,
          PreviewName: data.previewName,
          Country_Id: data.countryId,
          BrandColor: data.brandColor,
        }),
      }),
    )(),

  tenantRegStructureDetail: async tenantId =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantRegStructureDetail,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
      }),
    )(),

  tenantRegStructureDetailUpdate: async (tenantId, data) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantRegStructureDetailUpdate,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
        data: makeFormData({
          TenantType: data.tenantType,
        }),
      }),
    )(),

  tenantRegDefinitionDetail: async tenantId =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantRegDefinitionDetail,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
      }),
    )(),

  tenantRegDefinitionDetailUpdate: async (tenantId, data) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantRegDefinitionDetailUpdate,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
        data: makeFormData({
          TenantDefinition_Id: data.tenantDefinitionId,
        }),
      }),
    )(),

  tenantRegLogoUpload: async ({ id, file }) =>
    makeApiRequest(async () => {
      const response = await Requester.post({
        url: managementApiEndpoints.tenantRegUploadLogo,
        data: makeFormData({ file }),
        queryParams: { Id: id },
        apiClient: apiClientWithTenantIdHeader(id),
      })

      return response
    })(),

  tenantRegLogoDownloadImage: async (id, signal) =>
    makeApiRequest(async () => {
      const response = await Requester.put({
        url: managementApiEndpoints.tenantRegDownloadLogo,
        queryParams: { Id: id },
        apiClient: apiClientWithTenantIdHeader(id),
        signal,
      })

      return response
    })(),

  tenantRegAppLogoUpload: async ({ id, file }) =>
    makeApiRequest(async () => {
      const response = await Requester.post({
        url: managementApiEndpoints.tenantRegUploadAppLogo,
        data: makeFormData({ file }),
        queryParams: { Id: id },
        apiClient: apiClientWithTenantIdHeader(id),
      })

      return response
    })(),

  tenantRegAppLogoDownloadImage: async (id, signal) =>
    makeApiRequest(async () => {
      const response = await Requester.put({
        url: managementApiEndpoints.tenantRegDownloadAppLogo,
        queryParams: { Id: id },
        apiClient: apiClientWithTenantIdHeader(id),
        signal,
      })

      return response
    })(),

  tenantRegTerminologyDetailUpdate: async (tenantId, data) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantRegTerminologyDetailUpdate,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
        data: makeFormData({
          Terminologies: JSON.stringify(data),
        }),
      }),
    )(),

  tenantRegTerminologyDetail: async tenantId =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantRegTerminologyDetail,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
      }),
    )(),

  tenantRegComponentDetailUpdate: async (tenantId, data) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantRegComponentDetailUpdate,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
        data: makeFormData({
          Components: JSON.stringify(data),
        }),
      }),
    )(),

  tenantRegComponentDetail: async tenantId =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantRegComponentDetail,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
      }),
    )(),

  tenantRegBackgroundImageDownload: async id =>
    makeApiRequest(async () => {
      const response = await Requester.put({
        url: managementApiEndpoints.tenantRegBackgroundImageDownload,
        queryParams: { Id: id },
        apiClient: apiClientWithTenantIdHeader(id),
      })

      return response
    })(),

  tenantRegBackgroundImageUpload: async (id, file) =>
    makeApiRequest(async () => {
      const response = await Requester.post({
        url: managementApiEndpoints.tenantRegBackgroundImageUpload,
        data: makeFormData({ file }),
        queryParams: { Id: id },
        apiClient: apiClientWithTenantIdHeader(id),
      })

      return response
    })(),

  tenantRegProfileFinalize: async () =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantRegProfileFinalize,
      }),
    )(),

  tenantRegTenantRegistrationFinalize: async (tenantId, parentOrgId) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantRegTenantRegistrationFinalize,
        queryParams: { Id: tenantId, OrganisationTenantId: parentOrgId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
      }),
    )(),

  tenantRegSportCategoryDetail: async tenantId =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantRegSportCategoryDetail,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
      }),
    )(),

  tenantRegSportCategoryUpdate: async (tenantId, sportCategoryId) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantRegSportCategoryUpdate,
        queryParams: { Id: tenantId },
        apiClient: apiClientWithTenantIdHeader(tenantId),
        data: makeFormData({
          SportCategory_Id: sportCategoryId,
        }),
      }),
    )(),

  profileDetailsGet: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.profileDetails,
      }),
    )(),

  profileDetailsUpdate: async ({ name, surname, phoneNumber, profileOrganisationRoleId }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.profileDetailsUpdate,
        data: makeFormData({
          Name: name,
          Surname: surname,
          PhoneNumber: phoneNumber,
          ProfileOrganisationRole_Id: profileOrganisationRoleId,
        }),
      }),
    )(),

  tenantRegistrationProfileGet: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantRegistrationProfile,
      }),
    )(),

  tenantRegistrationProfileUpdate: async (
    tenantId,
    { name, surName, phoneNumber, profileOrganizationRoleId },
  ) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantRegistrationProfileUpdate,
        apiClient: apiClientWithTenantIdHeader(tenantId),
        data: makeFormData({
          Name: name,
          Surname: surName,
          PhoneNumber: phoneNumber,
          ProfileOrganizationRole_Id: profileOrganizationRoleId,
        }),
        queryParams: { Id: tenantId },
      }),
    )(),

  inventoryList: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.inventory.list,
      }),
    )(),

  inventoryAdd: async ({ name, price, viewOrder }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.inventory.add,
        data: makeFormData({
          Name: name,
          Price: price,
          ViewOrder: viewOrder,
        }),
      }),
    )(),

  inventoryUpdate: async ({ id, name, price, viewOrder }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.inventory.update,
        data: makeFormData({
          Id: id,
          Name: name,
          Price: price,
          ViewOrder: viewOrder,
        }),
      }),
    )(),

  inventoryDetails: async id =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.inventory.details,
        queryParams: { Id: id },
      }),
    )(),

  inventoryDelete: async id =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.inventory.delete,
        data: makeFormData({ Id: id }),
      }),
    )(),

  inventoryImageUpload: async ({ id, file }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.inventoryImage.upload,
        data: makeFormData({ file }),
        queryParams: { Id: id },
      }),
    )(),

  inventoryImageDownload: async id =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.inventoryImage.download,
        data: makeFormData({ Id: id }),
      }),
    )(),

  membershipList: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.membership.list,
      }),
    )(),

  membershipAdd: async data =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.membership.add,
        data: makeFormData({
          Name: data.name,
          Description: data.description,
          Badge: data.badge,
          Type: data.type,
          Status: data.status,
          SetPlanPrice: data.setPlanPrice,
          MembershipLength: data.membershipLength,
          MembershipLengthType: data.membershipLengthType,
          IsFreeOfCharge: data.isFreeOfCharge,
          DynamicTemplate_Id: data.dynamicTemplateId,
          MembershipCategory_Id: data.membershipCategoryId,
          ViewOrder: data.viewOrder,
        }),
      }),
    )(),

  membershipUpdate: async data =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.membership.update,
        data: makeFormData({
          Id: data.id,
          Name: data.name,
          Description: data.description,
          Badge: data.badge,
          Type: data.type,
          Status: data.status,
          SetPlanPrice: data.setPlanPrice,
          MembershipLength: data.membershipLength,
          MembershipLengthType: data.membershipLengthType,
          IsFreeOfCharge: data.isFreeOfCharge,
          DynamicTemplate_Id: data.dynamicTemplateId,
          MembershipCategory_Id: data.membershipCategoryId,
          ViewOrder: data.viewOrder,
        }),
      }),
    )(),

  membershipDetails: async id =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.membership.details,
        queryParams: { Id: id },
      }),
    )(),

  membershipDelete: async id =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.membership.delete,
        queryParams: { Id: id },
      }),
    )(),

  // Membership detail
  membershipDetailList: async membershipId =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.membershipDetail.list,
        queryParams: { MembershipId: membershipId },
      }),
    )(),

  membershipDetailAdd: async data =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.membershipDetail.add,
        data: makeFormData({
          Membership_Id: data.membershipId,
          PersonType_Id: data.personTypeId,
          Price: data.price,
          TotalPeopleInPlan: data.totalPeopleInPlan,
          ViewOrder: data.viewOrder,
          ExceeedLimit: data.exceeedLimit,
        }),
      }),
    )(),

  membershipDetailUpdate: async data =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.membershipDetail.update,
        data: makeFormData({
          Id: data.id,
          Membership_Id: data.membershipId,
          PersonType_Id: data.personTypeId,
          Price: data.price,
          TotalPeopleInPlan: data.totalPeopleInPlan,
          ViewOrder: data.viewOrder,
          ExceeedLimit: data.exceeedLimit,
        }),
      }),
    )(),

  membershipDetailDetails: async id =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.membershipDetail.details,
        queryParams: { Id: id },
      }),
    )(),

  membershipDetailDelete: async id =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.membershipDetail.delete,
        queryParams: { Id: id },
      }),
    )(),

  // Member registration
  memberRegistrationList: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.memberRegistration.list,
      }),
    )(),

  memberRegistrationAdd: async data =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.memberRegistration.add,
        data: makeFormData({
          Membership_Id: data.membershipId,
          Data: data.data,
          RegisterationStep: data.registrationStep,
          ViewOrder: data.viewOrder,
        }),
      }),
    )(),

  memberRegistrationUpdate: async data =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.memberRegistration.update,
        data: makeFormData({
          Membership_Id: data.membershipId,
          Data: data.data,
          RegisterationStep: data.registrationStep,
          ViewOrder: data.viewOrder,
        }),
        queryParams: { Id: data.id },
      }),
    )(),

  memberRegistrationDetails: async id =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.memberRegistration.details,
        queryParams: { Id: id },
      }),
    )(),

  // status MemberRegistrationStatus
  memberRegistrationUpdateStatus: async ({ id, status }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.memberRegistrationUpdateStatus,
        queryParams: { Id: id },
        data: makeFormData({ Status: status }),
      }),
    )(),

  memberRegistrationProfileMembership: async ({ id, data }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.memberRegistrationProfileMembership,
        queryParams: { Id: id },
        data: makeFormData({
          Data: JSON.stringify(data),
        }),
      }),
    )(),

  // data: MemberRegistrationProfileDTO = {ProfileintId: number}[]
  memberRegistrationFinalize: async ({ id, data }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.memberRegistrationFinalize,
        queryParams: { Id: id },
        data: makeFormData({ Data: data }),
      }),
    )(),

  // id member reg id
  memberRegistrationCartItems: async id =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.memberRegistrationCart,
        queryParams: { MemberRegistrationId: id },
      }),
    )(),

  memberRegistrationCartAdd: async ({ memberRegistrationId, inventoryIntId, InventoryPrice }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.memberRegistrationCartAdd,
        queryParams: { MemberRegistrationId: memberRegistrationId },
        data: makeFormData({
          InventoryintId: inventoryIntId,
          InventoryPrice: InventoryPrice,
        }),
      }),
    )(),

  // id uuid
  memberRegistrationCartRemove: async ({ memberRegistrationId, id }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.memberRegistrationCartRemove,
        queryParams: { MemberRegistrationId: memberRegistrationId },
        data: makeFormData({ Id: id }),
      }),
    )(),

  baseFeeList: async ({ membershipId }) =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.baseFee.list,
        data: makeFormData({ MembershipId: membershipId }),
      }),
    )(),

  // Membership_Id int
  baseFeeAdd: async ({ membershipId, feeFrequency, name, description, price, viewOrder }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.baseFee.add,
        data: makeFormData({
          Membership_Id: membershipId,
          FeeFrequency: feeFrequency,
          Name: name,
          Description: description,
          Price: price,
          ViewOrder: viewOrder,
        }),
      }),
    )(),

  baseFeeUpdate: async ({ id, membershipId, name, description, feeFrequency, price, viewOrder }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.baseFee.update,
        queryParams: { Id: id },
        data: makeFormData({
          Membership_Id: membershipId,
          FeeFrequency: feeFrequency,
          Name: name,
          Description: description,
          Price: price,
          ViewOrder: viewOrder,
        }),
      }),
    )(),

  baseFeeDelete: async id =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.baseFee.delete,
        queryParams: { Id: id },
        data: makeFormData({ Id: id }),
      }),
    )(),

  // baseFeeId uuid
  baseFeeDetailsGet: async baseFeeId =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.baseFee.details,
        queryParams: { Id: baseFeeId },
      }),
    )(),

  // memberType base fee
  // it should be membershipDetailId uuid
  memberTypeBaseFeeList: async ({ memberDetailId }) =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.memberTypeBaseFee.list,
        data: makeFormData({
          MembershipId: memberDetailId,
        }),
      }),
    )(),

  // MembershipDetail_Id int
  memberTypeBaseFeeAdd: async ({
    membershipDetailId,
    feeFrequency,
    name,
    description,
    price,
    isExceedFee,
    viewOrder,
  }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.memberTypeBaseFee.add,
        data: makeFormData({
          MembershipDetail_Id: membershipDetailId,
          FeeFrequency: feeFrequency,
          Name: name,
          Description: description,
          Price: price,
          ViewOrder: viewOrder,
          IsExceedFee: isExceedFee,
        }),
      }),
    )(),

  // MembershipDetail_Id int
  memberTypeBaseFeeUpdate: async ({
    id,
    membershipDetailId,
    name,
    description,
    feeFrequency,
    price,
    isExceedFee,
    viewOrder,
  }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.memberTypeBaseFee.update,
        queryParams: { Id: id },
        data: makeFormData({
          MembershipDetail_Id: membershipDetailId,
          FeeFrequency: feeFrequency,
          Name: name,
          Description: description,
          Price: price,
          ViewOrder: viewOrder,
          IsExceedFee: isExceedFee,
        }),
      }),
    )(),

  memberTypeBaseFeeDelete: async id =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.memberTypeBaseFee.delete,
        queryParams: { Id: id },
        data: makeFormData({ Id: id }),
      }),
    )(),

  // memberTypeBaseFeeId uuid
  memberTypeBaseFeeDetailsGet: async memberTypeBaseFeeId =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.memberTypeBaseFee.details,
        queryParams: { Id: memberTypeBaseFeeId },
      }),
    )(),

  /**
   * Tenant
   */
  tenantList: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenant.list,
      }),
    )(),

  tenantListAll: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenant.list,
        data: makeFormData({
          numberOfObjectsPerPage: 100_000,
        }),
      }),
    )(),

  tenantAdd: async payload =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenant.add,
        data: makeFormData({ ...payload }),
      }),
    )(),

  tenantUpdate: async payload =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenant.update,
        data: makeFormData({ ...payload }),
        queryParams: { Id: payload.id },
      }),
    )(),

  tenantGetDetails: async id =>
    makeApiRequest(async () => {
      const response = await Requester.put({
        url: managementApiEndpoints.tenant.details,
        queryParams: { Id: id },
        skipTenantIdHeader: true,
      })

      return response
    })(),

  tenantGetMyDetails: async () =>
    makeApiRequest(async () => {
      const response = await Requester.post({
        url: managementApiEndpoints.myTenantDetails,
      })

      return response
    })(),

  /**
   * tenantOsiAccess
   */
  tenantOsiAccessList: async tenantId =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantOsiAccess.list,
        queryParams: { TenantId: tenantId },
      }),
    )(),

  // tenantId int
  // osiAccessId int
  tenantOsiAccessAdd: async ({ tenantId, osiAccessId }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantOsiAccess.add,
        data: makeFormData({
          Tenant_Id: tenantId,
          osiAccess_Id: osiAccessId,
        }),
      }),
    )(),

  // tenantId int
  // osiAccessId int
  tenantOsiAccessUpdate: async ({ id, tenantId, osiAccessId }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantOsiAccess.add,
        data: makeFormData({
          Tenant_Id: tenantId,
          osiAccess_Id: osiAccessId,
        }),
        queryParams: { Id: id },
      }),
    )(),

  // id uuid
  tenantOsiAccessDetailsGet: async id =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantOsiAccess.details,
        queryParams: { Id: id },
      }),
    )(),

  // id uuid
  tenantOsiAccessDelete: async id =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantOsiAccess.delete,
        queryParams: { Id: id },
        data: makeFormData({ Id: id }),
      }),
    )(),
  // id uuid
  getTenantProfileDetailGlobal: async profileId =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.getTenantProfileDetailGlobal,
        queryParams: { profileId },
      }),
    )(),
  getGroupCodeList: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.getGroupCodeList,
      }),
    )(),

  getTenantProfileList: async () =>
    makeApiRequest(function () {
      return Requester.put({
        url: managementApiEndpoints.getTenantProfileList,
        data: makeFormData({
          numberOfObjectsPerPage: 100_000,
        }),
      })
    })(),

  getTenantProfileListNoUsers: async () =>
    makeApiRequest(function () {
      return Requester.put({
        url: managementApiEndpoints.getTenantProfileListNoUsers,
        data: makeFormData({
          numberOfObjectsPerPage: 100_000,
        }),
      })
    })(),

  getTenantGroupDetailWithSubGroup: async groupGuid =>
    makeApiRequest(function () {
      return Requester.put({
        url: managementApiEndpoints.getTenantGroupDetailWithSubGroup,
        queryParams: { groupGuid },
      })
    })(),

  pulicFileDownload: async ({ connectedId, type, tenantId }) =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.publicFileDownload,
        data: makeFormData({ ConnectedId: connectedId, Type: type }),
        headers: { 'X-Tenant-Id': tenantId, 'Tenant-Id': tenantId },
      }),
    )(),

  pulicFileUpload: async ({ connectedId, type, file, tenantId, removeFileId }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.publicFileUpload,
        data: makeFormData({ Type: type, file, RemoveFileId: removeFileId }),
        queryParams: { ConnectedId: connectedId },
        headers: { 'X-Tenant-Id': tenantId, 'Tenant-Id': tenantId },
      }),
    )(),

  tenantOsiSettings: async tenantId =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantOsiSettings,
        headers: { 'X-Tenant-Id': tenantId, 'Tenant-Id': tenantId },
      }),
    )(),

  sendNotification: async ({
    title,
    body,
    sentToList,
    type,
    link,
    imageUrl,
    questionTitle,
    hasQuestionnaireMaybeButton,
    allowQuestionnaireComment,
    allowUserToSeeResponse,
    startDateTime,
    endDateTime,
  }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.sendNotification,
        data: makeFormData({
          title,
          body,
          sentToList,
          type,
          link,
          imageUrl,
          questionTitle,
          hasQuestionnaireMaybeButton,
          allowQuestionnaireComment,
          allowUserToSeeResponse,
          startDateTime,
          endDateTime,
        }),
      }),
    )(),

  notificationDetails: async id =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.notificationDetail,
        queryParams: { Id: id },
      }),
    )(),

  selector: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.selector,
      }),
    )(),

  selectorEmbeds: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.selectorEmbeds,
      }),
    )(),

  selectorEmbedSub: async ({ sub }) =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.selectorEmbedSub,
        queryParams: { sub },
      }),
    )(),

  selectorProfiles: async ({ parameters }) => {
    const selectedTermIdQueryParam = new URLSearchParams(window.location.search).get(
      'selectedTermId',
    )

    return makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.selectorGetEmailRecipients,
        queryParams: {
          ...parameters,
          ...(selectedTermIdQueryParam ? { term: selectedTermIdQueryParam } : {}),
        },
      }),
    )()
  },

  selectorProfilesByEmail: async () => {
    const authStore = useAuthStore()
    const email = authStore.myDetails?.email
    const data = makeFormData({ Email: email || '' })

    return makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.selectorGetEmailRecipients,
        data,
      }),
    )()
  },

  /**
   * TenantMobile
   */
  tenantMobileList: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantMobile.list,
      }),
    )(),

  tenantMobileAdd: async data =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantMobile.add,
        data: makeFormData({
          Name: data.name,
          LogoUrl: data.logoUrl,
          HeaderUrl: data.headerUrl,
          SponsorUrl: data.sponsorUrl,
          ButtonsSettingsJson: data.buttonsSettingsJson,
          Website: data.website,
          Email: data.email,
          Location: data.location,
          Phone: data.phone,
          Facebook: data.facebook,
          Instagram: data.instagram,
          Linkedin: data.linkedin,
          Twitter: data.twitter,
          showWebsite: data.showWebsite,
          showEmail: data.showEmail,
          showLocation: data.showLocation,
          showPhone: data.showPhone,
          showFacebook: data.showFacebook,
          showInstagram: data.showInstagram,
          showLinkedin: data.showLinkedin,
          showTwitter: data.showTwitter,
          Extra: data.extra,
          Extra1: data.extra1,
          Extra2: data.extra2,
          isActive: data.isActive,
          ViewOrder: data.viewOrder,
          SponsorUrlHref: data.sponsorUrlHref,
          showProfileId: data.showProfileId,
        }),
      }),
    )(),

  tenantMobileUpdate: async ({ id, ...data }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantMobile.update,
        queryParams: { Id: id },
        data: makeFormData({
          Name: data.name,
          LogoUrl: data.logoUrl,
          HeaderUrl: data.headerUrl,
          SponsorUrl: data.sponsorUrl,
          ButtonsSettingsJson: data.buttonsSettingsJson,
          Website: data.website,
          Email: data.email,
          Location: data.location,
          Phone: data.phone,
          Facebook: data.facebook,
          Instagram: data.instagram,
          Linkedin: data.linkedin,
          Twitter: data.twitter,
          showWebsite: data.showWebsite,
          showEmail: data.showEmail,
          showLocation: data.showLocation,
          showPhone: data.showPhone,
          showFacebook: data.showFacebook,
          showInstagram: data.showInstagram,
          showLinkedin: data.showLinkedin,
          showTwitter: data.showTwitter,
          Extra: data.extra,
          Extra1: data.extra1,
          Extra2: data.extra2,
          isActive: data.isActive,
          ViewOrder: data.viewOrder,
          SponsorUrlHref: data.sponsorUrlHref,
          showProfileId: data.showProfileId,
        }),
      }),
    )(),

  tenantMobileGetDetails: async id =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantMobileGetDetails,
        queryParams: { Id: id },
      }),
    )(),

  tenantMobileDelete: async id =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantMobile.delete,
        queryParams: { Id: id },
      }),
    )(),

  tenantMobileRecover: async id =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantMobileRecover,
        queryParams: { Id: id },
      }),
    )(),

  tenantMobileUpdateStatus: async ({ id, active }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantMobileUpdateStatus,
        queryParams: { Id: id },
        data: makeFormData({ active }),
      }),
    )(),

  /**
   * TenantMobileContact
   */
  tenantMobileContactList: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantMobileContact,
      }),
    )(),

  tenantMobileContactAdd: async data =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantMobileContactAdd,
        data: makeFormData({
          ProfileName: data.profileName,
          ProfileEmail: data.profileEmail,
          ProfilePhone: data.profilePhone,
          ProfilePosition: data.profilePosition,
          ProfileId: data.profileId,
          showPhone: data.showPhone,
          showEmail: data.showEmail,
        }),
      }),
    )(),

  tenantMobileContactUpdate: async ({ id, profilePosition, showPhone, showEmail }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantMobileContactUpdate,
        queryParams: { Id: id },
        data: makeFormData({
          ProfilePosition: profilePosition,
          showPhone: showPhone,
          showEmail: showEmail,
        }),
      }),
    )(),

  tenantMobileContactRemove: async id =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantMobileContactRemove,
        queryParams: { Id: id },
      }),
    )(),

  /**
   * TenantMobileGroup
   */
  tenantMobileGroupList: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantMobileGroup,
      }),
    )(),

  tenantMobileGroupAdd: async ({ groupId, groupName }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantMobileGroupAdd,
        data: makeFormData({
          GroupId: groupId,
          GroupName: groupName,
        }),
      }),
    )(),

  tenantMobileGroupRemove: async id =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantMobileGroupRemove,
        queryParams: { Id: id },
      }),
    )(),

  mobileChatHide: async id =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.mobileChatHide,
        queryParams: { Id: id },
      }),
    )(),

  mobileChatReportDetail: async id =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.mobileChatReportDetail,
        queryParams: { Id: id },
      }),
    )(),

  tenantSportType: async tenantId =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantSportType,
        headers: { 'X-Tenant-Id': tenantId, 'Tenant-Id': tenantId },
      }),
    )(),

  tenantSportTypeAdd: async (tenantId, sportTypeId) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantSportTypeAdd,
        data: makeFormData({ SportTypeId: sportTypeId }),
        headers: { 'X-Tenant-Id': tenantId, 'Tenant-Id': tenantId },
      }),
    )(),

  tenantSportTypeRemove: async (tenantId, id) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.tenantSportTypeRemove,
        queryParams: { Id: id },
        headers: { 'X-Tenant-Id': tenantId, 'Tenant-Id': tenantId },
      }),
    )(),

  tenantReport: async tenants =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantReport,
        data: makeFormData({ tenants: JSON.stringify(tenants) }),
      }),
    )(),

  tenantMobileContactListWithClubId: async tenantId =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.tenantMobileContact,
        apiClient: apiClientWithTenantIdHeader(tenantId),
      }),
    )(),

  mobileGroupAddChatGroup: async ({
    name,
    desc,
    groupId,
    termId,
    termStartDate,
    termEndDate,
    chatGroupType,
    daysBeforeTermStart,
    daysAfterTermEnd,
  }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.mobileGroupAddChatGroup,
        data: makeFormData({
          Name: name,
          Description: desc,
          GroupId: groupId,
          TermId: termId,
          TermStartDate: termStartDate,
          TermEndDate: termEndDate,
          ChatGroupType: chatGroupType,
          DaysBeforeTermStart: daysBeforeTermStart,
          DaysAfterTermEnd: daysAfterTermEnd,
        }),
      }),
    )(),

  mobileGroupRemoveChatGroup: async id =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.mobileGroupRemoveChatGroup,
        queryParams: { Id: id },
      }),
    )(),

  mobileGroupAddChatGroupMember: async ({ chatGroupId, profiles }) =>
    makeApiRequest(() =>
      Requester.post({
        url: managementApiEndpoints.mobileGroupAddChatGroupMember,
        data: makeFormData({ ChatGroupId: chatGroupId, Profiles: JSON.stringify(profiles) }),
      }),
    )(),

  mobileGroupGetGroupTerms: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.mobileGroupGetGroupTerms,
      }),
    )(),

  mobileGroupGetSelectedTermsGroup: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.mobileGroupGetSelectedTermsGroup,
      }),
    )(),

  getProfileGroupsV2NoMobileConnection: async () =>
    makeApiRequest(() =>
      Requester.put({
        url: managementApiEndpoints.getProfileGroupsV2NoMobileConnection,
      }),
    )(),
}
